export default {
  sendMail: {
    success: 'Vous allez recevoir un email avec un lien valide 24 heures. En cliquant sur ce lien vous arriverez sur nouvelle page où vous pourrez choisir votre nouveau mot de passe pour vous connecter',
    error: 'Impossible de réinitialiser votre mot de passe'
  },
  confirmReset: {
    success: 'Mot de passe réinitialisé avec succès.',
    error: 'Impossible de réinitialiser votre mot de passe'
  }
}
